import { notification } from "antd"
import Strings from "utils/strings"

export const trimObjects = (obj: any) => {
	for (const prop in obj) {
		obj[prop] = obj[prop].trim()
	}
	return obj
}

export const emailIsValid = (email: string, error?: any) => {
	const emailRegex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	const isValid = email.match(emailRegex)

	if (!isValid && error) {
		notification.warn({
			message: Strings.errors.invalidFields,
			description: error as string,
			placement: "bottomRight",
			duration: 5,
		})
	}

	return isValid
}

// Translate non-delivery reason
export const translateNonDeliveryReason = (
	reason: string,
	mapOfReason: any
) => {
	const lang = Strings.getLanguage()
	const reasonData = mapOfReason?.[reason]
	return reasonData?.[lang] || reasonData?.pt || reasonData?.en || reason
}

export const capitalize = (string: string) => {
	if (!string) return ""
	return `${string.charAt(0).toUpperCase()}${string.slice(1)}`
}

export const translate = (text: any) => {
	if (!text) return ""

	if (typeof text === "string") return text

	const lang = Strings.getLanguage()
	const defaultLanguage = Strings.getLanguage()

	if (text[defaultLanguage] || text[lang]) {
		return text[defaultLanguage] || text[lang]
	}

	return Object.values(text).filter((val) => !!val)[0] || ""
}

export const humanFileSize = (bytes: number, si = false, dp = 1) => {
	const thresh = si ? 1000 : 1024

	if (Math.abs(bytes) < thresh) {
		return bytes + " B"
	}

	const units = si
		? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
		: ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
	let u = -1
	const r = 10 ** dp

	do {
		bytes /= thresh
		++u
	} while (
		Math.round(Math.abs(bytes) * r) / r >= thresh &&
		u < units.length - 1
	)

	return bytes.toFixed(dp) + " " + units[u]
}

export const LANGUAGES = [
	{
		value: "pt",
		label: "PT",
	},
	{
		value: "en",
		label: "EN",
	},
	{
		value: "es",
		label: "ES",
	},
]

/**
 * Fixes text with encoding corruption (UTF-8 bytes decoded as Latin-1),
 * e.g. "Bar\u00c3 o" → "Barão", "CAL\u00c3\u0083ADA" → "CALÇADA".
 * Falls back to NFC normalization if the re-decoding produces replacement chars.
 */
export function sanitizeText(str: string): string {
	try {
		const bytes = Uint8Array.from(str, (c) => c.charCodeAt(0))
		const decoded = new TextDecoder("utf-8").decode(bytes)
		if (!decoded.includes("\uFFFD")) return decoded
	} catch {
		// ignore decoding errors
	}
	// eslint-disable-next-line no-control-regex
	return str.normalize("NFC").replace(/[\x00-\x1F\x7F]/g, "")
}

export function translateImportError(error: string) {
	switch (error) {
		case "order_id":
			return Strings.orders.duplicateOrderId
		case "order_not_found":
			return Strings.orders.orderNotFound
		case "order_not_in_packing":
			return Strings.orders.orderNotInPacking
		case "invalid_postcode":
			return Strings.orders.invalidPostCode
		case "missing_fields":
			return Strings.orders.missingMandatoryFields
		case "invalid_date_format":
			return Strings.orders.invalidDateFormat
		case "invalid_slot":
			return Strings.orders.invalidSlot
		case "invalid_bag_id":
			return Strings.orders.invalidBagId
		case "duplicate_order_id":
			return Strings.orders.duplicateOrderIdInFile
		case "failed_update":
			return Strings.orders.failedUpdate
		default:
			return error
	}
}
